var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 78,
    viewBox: "0 0 67 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "inwcmzvw7a",
    d: "M0 0L59 0 59 72 0 72z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-280 -173) rotate(-5 2187.031 -3128.335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8r31d2xxib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#inwcmzvw7a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00B2FD",
    d: "M11.4 64.893c-2.663 1.749-9.293 5.22-11.133 5.83-.296.1-.353.427-.136.774.95 1.527 7.64-.573 13.519-4.249 10.551-6.593 22.989-18.98 29.792-29.675 3.016-4.742 8.327-15.386 10.298-20.648l1.33-3.552.466 6.506c.375 5.236.619 6.606 1.24 6.993.567.351.985.311 1.548-.15.688-.569.753-1.902.62-12.449-.121-9.464-.286-12.018-.839-12.844C56.64-.77 55.248-.464 52.877 2.57 40.5 18.438 40.241 18.81 40.693 19.983c.586 1.51 2.292.736 5.523-2.495 1.77-1.77 3.285-3.155 3.366-3.074.215.212-2.67 7.202-5.112 12.386-7.34 15.594-18.648 28.616-33.07 38.093",
    mask: "url(#8r31d2xxib)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.0aaafecdcd76a48a8821266ca5679a38.svg";
export { ForwardRef as ReactComponent };